import { createStyles } from 'antd-style';

export const useStyles = createStyles(({ token, css }) => {
  return {
    container: css`
      flex: 0 0 auto;
      height: 56px;
      display: flex;
      align-items: center;
      padding-left: 14px;
      background: #fff;
      justify-content: space-between;
    `,
    title: css`
      font-size: 20px;
      font-weight: bold;
    `,
    menu: css`
      margin-right: 20px;
      cursor: pointer;
    `,
    left: css`
      display: flex;
      padding-left: 20px;
      align-items: center;
    `
  };
});
